import DashboardPage from '@components/pages/dashboard'
import { AppModule } from '@core/modules/app/app.module'
import { TechnologiesModule } from '@core/modules/digital-footprint/technologies/technologies.module'
import Typography from '@/ui/components/typography'
import { InlineScanIndicator } from '@/ui/components/inline-scan-indicator'
import { TableWrapper } from '@/ui/components/CustomTable/CustomTable.styles'
import { AddExternalAssetButton } from '@/ui/components/add-external-asset-button'
import TechnologiesHeader from './components/header'
import { TechnologiesTable } from './components/technologiesTable'
import { AssetsExport } from '@routes/digital-footprint/routes/assets/components/assetExport'
import { TitleWrapper } from '@routes/digital-footprint/routes/assets/assets.styles'
import TechnologiesSkeleton from './components/skeleton'

const TechnologiesPage = () => {
    const { loading } = TechnologiesModule.useStore()
    const data = TechnologiesModule.getData()
    const { scanInProgress } = AppModule.useStore()

    return (
        <DashboardPage
            name="technologies"
            loading={loading}
            hideScanInProgress
            pageActions={
                <AddExternalAssetButton
                    label="Add Technologies"
                    drawerContentType="addTechnologies"
                    analyticsEvent="SEM::user_clicks_at_add_technologies"
                    testId="add-technologies-button"
                />
            }
            skeleton={<TechnologiesSkeleton />}
        >
            <TableWrapper>
                <TitleWrapper>
                    <Typography variant="m-regular">Technologies</Typography>
                    <AssetsExport
                        assets={[]}
                        exportScope="technologies"
                        scanInProgress={!!scanInProgress}
                        technologies={data}
                    />
                    <InlineScanIndicator scanInProgress={!!scanInProgress} />
                </TitleWrapper>
                <TechnologiesHeader />
                <TechnologiesTable />
            </TableWrapper>
        </DashboardPage>
    )
}

export default TechnologiesPage
